// extracted by mini-css-extract-plugin
module.exports = {"link":"StrengthTestTable_link___aeTB"};